import {GetSeferData} from "SeferPetach/GetData";

export async function changePassword(obj) {    
    var args = {...obj};
    var payload = await GetSeferData("uupw", args);
    return (payload);
}
export async function changeSelfData(obj) {    
    var payload = await GetSeferData("uupref", {...obj});
    return (payload);
}